const biCockpit = () => import('@/view/biCockpit/index')
const cockpit = () => import('@/view/biCockpit/cockpit')
let router = [
    {
      path: '/biCockpit',
      component: biCockpit,
      name: 'biCockpit',
      redirect:"/cockpit",
      meta: {
        menuTitle: "BI驾驶舱",
        menuKey: "biCockpit",
        menuIcon: "icon-sale",
      },
      children:[
        {
          path:'cockpit',
          component:cockpit,
          name:"cockpit",
          meta:{
            menuKey:"biCockpit",
            // menuIcon: "el-icon-monitor",
          }
        }
      ]
    }
  ]
  export default router